import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useSession } from '@shared/hooks/useSession'

// Renders children only for unauthenticated users.
// If already authenticated, redirect to dashboard.
export function GuestRoute({ children }: { children: ReactNode }) {
  const { data, isLoading, error } = useSession()
  if (isLoading) return <div className="p-6">Loading…</div>
  if (!error && data?.authenticated) return <Navigate to="/" replace />
  return <>{children}</>
}

